import { render, staticRenderFns } from "./PesapalTransactionDetail.vue?vue&type=template&id=6aafd46c&scoped=true"
import script from "./PesapalTransactionDetail.vue?vue&type=script&lang=js"
export * from "./PesapalTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./PesapalTransactionDetail.vue?vue&type=style&index=0&id=6aafd46c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aafd46c",
  null
  
)

export default component.exports